import { useFormik } from "formik"
import React, { useEffect, useState, useRef } from "react"
import { useDispatch } from "react-redux"
import * as Yup from "yup"
import { Col, Row, Form, Label, Input, FormFeedback } from "reactstrap"
import { addNewSubCategory } from "store/manageclient/action"
import Select from "react-select"
import { customStylesSelect } from "common/data/settings"
import moment from "moment"
import { dateStringAt9AM, formatDateString, formatDateTime, getTimeSplit, onClosePicker } from 'helpers/util';

const subCatmodalform = ({
  handleCancel,
  selectedRow,
  isEdit,
  companyid,
  toggle,
  companySetting,
  selectedId,
  getallbillingtypes,
  setBillableType,
  billableType,
  projectManager,
  setProjectManagerId,
  projectManagerId,
  users,
  setUsersForProject,
  usersForProject,
  selectedProjectstatus,
  projectStatus,
  setSelectedProjectstatus
}) => {
  const dispatch = useDispatch()

  const userid = JSON.parse(localStorage.getItem("authUser") || "{}")?.data?.id
  const [previousDateTime, setPreviousDateTime] = useState(null);
  const datetimeInputRef = useRef(null);

  useEffect(() => {
    if (selectedRow?.billingType || selectedRow?.projectmanagerid) {
      const getBillableType = getallbillingtypes?.find(
        ele => ele?.id === selectedRow?.billingType
      )
      const getprojectManager = projectManager?.find(
        ele => ele?.id === selectedRow?.projectmanagerid
      )
      const getprojectstatus = projectStatus?.find(
        ele => ele?.id === selectedRow?.projectstatusid
      )

      setBillableType({
        ...getBillableType,
        label: getBillableType?.name,
        value: getBillableType?.id,
      })
      setProjectManagerId({
        ...projectManager,
        label: getprojectManager?.username,
        value: getprojectManager?.id,
      })
      setSelectedProjectstatus({
        ...projectStatus,
        label: getprojectstatus?.statusname,
        value: getprojectstatus?.id,
      })
    }

    if (selectedRow?.additionalReportingPersonResponse && isEdit) {
      const selectedusers = selectedRow?.additionalReportingPersonResponse.map(
        el => el.userId
      )
      const usersDetails = users.filter(data => selectedusers.includes(data.id))
      setUsersForProject(usersDetails)
    } else {
      setUsersForProject([])
    }
  }, [selectedRow])

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      name: isEdit ? selectedRow?.name : "",
      suspend: isEdit ? selectedRow?.suspend : false,
      restricted_user: isEdit ? selectedRow?.restrictbyassigneduser : true,
      billingType: isEdit ? selectedRow?.billingType : "",
      quotedhours:
        isEdit && selectedRow?.quoteHours != null
          ? selectedRow?.quoteHours
          : "",
      projectmanager: isEdit ? selectedRow?.projectmanagerid : "",
      projectusers: isEdit ? usersForProject : "",
      projectstatus: isEdit ? selectedRow?.projectstatusid : "",
      enableCustomLoginTime: isEdit ? selectedRow?.enableCustomLoginTime : false,
      customLoginTime: (isEdit && selectedRow?.customLoginTime && selectedRow?.customLoginTime != '0001-01-01T00:00:00') ? formatDateTime(selectedRow?.customLoginTime) : formatDateTime(dateStringAt9AM),
      // Minutes per work-report time slot (0 = disabled).
      reportInterval: isEdit ? (selectedRow?.maxreportinterval ?? 0) : 0
    },

    validationSchema: Yup.object({
      name: Yup.string().required(
        `Please Enter ${companySetting?.SubCategory} Name`
      ),
      billingType: Yup.string().required(`Please Select Billing Type`),
      quotedhours: Yup.string().when("billingType", {
        is: "3",
        then: Yup.string()
          .required("Please Enter Quoted Hours")
          .test(
            "greaterThanZero",
            "Quoted Hours must be greater than 0",
            value => parseFloat(value) > 0
          )
          .matches(/^\d+$/, "Only whole numbers are allowed"),
        otherwise: Yup.string(),
      }),
      projectmanager: Yup.string().required(`Please Select Project Manager`),
      projectstatus: Yup.string().nullable().required(`Please Select Project Status`),
      reportInterval: Yup.number()
        .typeError("Report Interval must be a number")
        .integer("Report Interval must be a whole number")
        .min(0, "Report Interval cannot be negative")
        .max(1440, "Report Interval cannot exceed 1440 minutes")
    }),

    onSubmit: values => {
      const reportingUsersActive = usersForProject.map(data => {
        const users = {
          userId: data.id,
          isactive: data.active,
        }
        return users
      })
      if (!isEdit) {
        const addnewSub = {
          companyid: companyid,
          categoryid: selectedId,
          name: values?.name,
          suspend: values?.suspend,
          restrictbyassigneduser: values?.restricted_user,
          createdbyuserid: userid,
          quotedHours: billableType?.value == 3 ? values?.quotedhours : 0,
          billingType: parseInt(values?.billingType),
          projectmanagerid: parseInt(values?.projectmanager),
          reportingUsersActive: reportingUsersActive,
          projectstatusid: values?.projectstatus,
          enableCustomLoginTime: values.enableCustomLoginTime,
          maxreportinterval: parseInt(values?.reportInterval) || 0,
          ...(values.enableCustomLoginTime && { customLoginTime: formatDateString(values.customLoginTime) })

        }
        dispatch(addNewSubCategory(addnewSub, handleResponse))
      } else {
        const EditSub = {
          subCategoryId: selectedRow?.id,
          companyid: companyid,
          categoryid: selectedId,
          name: values?.name,
          suspend: values?.suspend,
          restrictbyassigneduser: values?.restricted_user,
          createdbyuserid: userid,
          quotedHours: billableType?.value == 3 ? values?.quotedhours : 0,
          billingType: parseInt(values?.billingType),
          projectmanagerid: parseInt(values?.projectmanager),
          reportingUsersActive: reportingUsersActive,
          projectstatusid: values?.projectstatus,
          enableCustomLoginTime: values.enableCustomLoginTime ? values.enableCustomLoginTime : false,
          maxreportinterval: parseInt(values?.reportInterval) || 0,
          ...(values.enableCustomLoginTime && { customLoginTime: formatDateString(values.customLoginTime) })
        }
        dispatch(addNewSubCategory(EditSub, handleResponse))
      }
    },
  })

  const handleResponse = status => {
    if (status === "SUCCESS") {
      toggle()
      validation.resetForm()
    }
  }

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      // Customize the control (main input) styles
      borderColor:
        validation.touched.billingType && validation.errors.billingType
          ? "#f46a6a !important"
          : "#FFDBB1 !important",
      "& svg": {
        color:
          validation.touched.billingType && validation.errors.billingType
            ? "#f46a6a !important"
            : "green !important",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      // Customize the option styles
      backgroundColor: "white",
      borderColor:
        validation.touched.billingType && validation.errors.billingType
          ? "#f46a6a !important"
          : "#FFDBB1 !important",
      color: "black",
    }),
  }

  const onSelectBillable = value => {
    setBillableType(value)
    validation.setFieldValue("billingType", value?.id?.toString())
    if (billableType?.value !== 3) {
      validation.setFieldValue("quotedhours", 0)
    }
  }
  const onChangeQuotedHrs = e => {
    validation.setFieldValue("quotedhours", Math.round(Number(e.target.value)))
  }

  const onProjectManager = value => {
    setProjectManagerId(value)
    validation.setFieldValue("projectmanager", value?.id)
  }

  const onChangeUsers = value => {
    setUsersForProject(value)
    validation.setFieldValue("projectusers", value)
  }
  // handle project status in add and  edit project concept
  const HandleProjectStatus = value => {
    setSelectedProjectstatus(value)
    validation.setFieldValue("projectstatus", value?.id)
  }

  const handleDateTimeChange = (event) => {
    const newValue = event.target.value;
    const newTime = getTimeSplit(newValue);
    if (previousDateTime) {
      onClosePicker(newTime, previousDateTime, datetimeInputRef)
    }
    validation.setFieldValue("customLoginTime", newValue)
    setPreviousDateTime(newValue);
  };

  return (
    <Form
      onSubmit={e => {
        e.preventDefault()
        validation.handleSubmit()
        return false
      }}
    >
      <Row form>
        <Col>
          <div className="mb-3">
            <Label for="name" className="form-label">
              {companySetting?.SubCategory}
            </Label>
            <Input
              name="name"
              className="form-control"
              placeholder={`Enter ${companySetting?.SubCategory} Name`}
              type="text"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.name || ""}
              invalid={
                validation.touched.name && validation.errors.name ? true : false
              }
            />
            {validation.touched.name && validation.errors.name ? (
              <FormFeedback type="invalid">
                {validation.errors.name}
              </FormFeedback>
            ) : null}
          </div>
          <div className="mb-3">
            <Label className="form-label">{`Billable Type`}</Label>
            <Select
              styles={customStylesSelect}
              classNamePrefix="select2-selection"
              value={billableType}
              onChange={value => onSelectBillable(value)}
              placeholder={"Billable type"}
              invalid={
                validation.touched.billingType && validation.errors.billingType
                  ? true
                  : false
              }
              options={(getallbillingtypes || [])?.map(el => ({
                ...el,
                label: el.name,
                value: el.id,
              }))}
            />
            {validation.touched.billingType && validation.errors.billingType ? (
              <div style={{ color: "#f46a6a", fontSize: 10.4, marginTop: 5 }}>
                {validation.errors.billingType}
              </div>
            ) : null}
          </div>
          <div className="mb-3">
            <Label className="form-label">Work Report Interval (minutes)</Label>
            <Input
              name="reportInterval"
              className="form-control"
              placeholder="e.g. 30 (0 = disabled)"
              type="number"
              min={0}
              max={1440}
              value={validation.values.reportInterval}
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              invalid={
                validation.touched.reportInterval &&
                validation.errors.reportInterval
                  ? true
                  : false
              }
            />
            <small className="text-muted">
              A work report is required for every tracked slot of this length. 0 disables slot splitting.
            </small>
            {validation.touched.reportInterval &&
            validation.errors.reportInterval ? (
              <FormFeedback type="invalid">
                {validation.errors.reportInterval}
              </FormFeedback>
            ) : null}
          </div>
          {billableType?.name === "Quoted" && (
            <div className="mb-3">
              <Label className="form-label">{`Quoted Hours`}</Label>
              <Input
                name="name"
                className="form-control"
                placeholder={`Enter the quote hours`}
                type="number"
                value={validation.values.quotedhours}
                max={9999}
                maxLength={4}
                invalid={
                  validation.touched.quotedhours &&
                    validation.errors.quotedhours
                    ? true
                    : false
                }
                onChange={e => onChangeQuotedHrs(e)}
              />
              {validation.touched.quotedhours &&
                validation.errors.quotedhours ? (
                <FormFeedback type="invalid">
                  {validation.errors.quotedhours}
                </FormFeedback>
              ) : null}
            </div>
          )}

          <div className="mb-3">
            <Label className="form-label">Project Manager</Label>
            <Select
              styles={customStylesSelect}
              classNamePrefix="select2-selection"
              value={projectManagerId}
              onChange={value => onProjectManager(value)}
              placeholder={"Project Manager"}
              invalid={
                validation.touched.projectmanager &&
                  validation.errors.projectmanager
                  ? true
                  : false
              }
              options={projectManager?.map(el => ({
                ...el,
                label: el.username,
                value: el.id,
              }))}
            />
            {validation.touched.projectmanager &&
              validation.errors.projectmanager ? (
              <div style={{ color: "#f46a6a", fontSize: 10.4, marginTop: 5 }}>
                {validation.errors.projectmanager}
              </div>
            ) : null}
          </div>

          <div className="mb-3">
            <Label className="form-label">Additional Reporting Users</Label>
            <Select
              classNamePrefix="select2-selection"
              value={usersForProject}
              onChange={value => onChangeUsers(value)}
              placeholder={"Project Users"}
              options={users}
              isMulti
              styles={customStylesSelect}
            />
          </div>
          <div className="mb-3">
            <Label className="form-label">Project Status</Label>
            <Select
              styles={customStylesSelect}
              classNamePrefix="select2-selection"
              value={selectedProjectstatus}
              onChange={value => HandleProjectStatus(value)}
              placeholder={"Project Status"}
              invalid={
                validation.touched.projectstatus &&
                  validation.errors.projectstatus
                  ? true
                  : false
              }
              options={projectStatus?.map(el => ({
                ...el,
                label: el.statusname,
                value: el.id,
              }))}
            />
            {validation.touched.projectstatus &&
              validation.errors.projectstatus ? (
              <div style={{ color: "#f46a6a", fontSize: 10.4, marginTop: 5 }}>
                {validation.errors.projectstatus}
              </div>
            ) : null}
          </div>
          <Row>
            <Col>
              <div className="form-check mb-3">
                <Input
                  className="form-check-input"
                  type="checkbox"
                  defaultChecked={validation.values.enableCustomLoginTime}
                  onChange={(e)=> validation.setFieldValue('enableCustomLoginTime', e.target.checked)}
                  id="enableCustomLoginTime"
                  name="enableCustomLoginTime"
                />

                <Label className="form-check-label" htmlFor="enableCustomLoginTime">
                  Custom Login Time
                </Label>
              </div>
            </Col>
          </Row>
          {validation.values.enableCustomLoginTime &&
            <Row className="mb-3">
              <div className="col-md-12">
                <input
                  placeholder='Please select time'
                  className="form-control"
                  type="datetime-local"
                  value={validation.values.customLoginTime}
                  onChange={event =>
                    handleDateTimeChange(event)
                  }
                  id={'customLoginTime'}
                  ref={datetimeInputRef}
                />
              </div>
            </Row>
          }
          <Row>
            <Col sm={4}>
              <div className="form-check mb-3">
                <Input
                  className="form-check-input"
                  type="checkbox"
                  onChange={(e)=> validation.setFieldValue('suspend', e.target.checked)}
                  defaultChecked={validation.values?.suspend}
                  id="suspend"
                />
                <Label className="form-check-label" htmlFor="suspend">
                  Suspend
                </Label>
              </div>
            </Col>
            <Col sm={4}>
              <div className="form-check mb-3">
                <Input
                  className="form-check-input"
                  type="checkbox"
                  onChange={(e)=> validation.setFieldValue('restricted_user', e.target.checked)}
                  defaultChecked={validation.values?.restricted_user}
                  id="restricted_user"
                />
                <Label className="form-check-label" htmlFor="restricted_user">
                  Restricted User
                </Label>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <div className="text-end">
        <button type="submit" className="btn btn-primary save-customer me-2">
          Save
        </button>
        <button
          type="button"
          color="primary"
          className="btn btn-secondary"
          onClick={handleCancel}
        >
          Cancel
        </button>
      </div>
    </Form>
  )
}

export default subCatmodalform
